import {ACTION_EVENTS} from "../../UserAction";
import {ELEMENT_IDS} from "../MobileDOM";
import {BASE_ELEMENT_IDS} from "../../BaseDOM";

export function createInfopages(parent) {

    let leftButton = document.createElement("button");
    leftButton.id = ELEMENT_IDS.INFO_BUTTON_LEFT;
    leftButton.classList.add("mx-button", "mx-input", "mx-info-left");
    $(leftButton).data("action", ACTION_EVENTS.ACTION_INFO_ARROW);
    $(leftButton).data("data", "left");
    parent.appendChild(leftButton);

    let rightButton = document.createElement("button");
    rightButton.classList.add("mx-button", "mx-input", "mx-info-right");
    rightButton.id = ELEMENT_IDS.INFO_BUTTON_RIGHT;
    $(rightButton).data("action", ACTION_EVENTS.ACTION_INFO_ARROW);
    $(rightButton).data("data", "right");
    parent.appendChild(rightButton);

    let closeButton = document.createElement("button");
    closeButton.classList.add("mx-button", "mx-input", "mx-info-close");
    closeButton.id = ELEMENT_IDS.INFO_BUTTON_CLOSE;
    $(closeButton).data("action", ACTION_EVENTS.ACTION_INFO_TOGGLE);
    parent.appendChild(closeButton);
}

export function createPreinfoClose(parent) {
    let btn = document.createElement("button");
    btn.id = BASE_ELEMENT_IDS.BUTTON_PREINFO_CLOSE;
    btn.classList.add("mx-input", "mx-button", "mx-button-preinfo-close", "mx-icon-check");
    $(btn).hide();
    // $(btn).data("action", ACTION_EVENTS.ACTION_PREINFO_CLOSE);


    parent.appendChild(btn);
}